"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/no-extraneous-dependencies
const keytar_1 = __importDefault(require("keytar"));
// TODO decide if globalObject is the best choice
class CredentialsStorage {
    constructor(account = 'Bitloops') {
        this.account = account;
    }
    //   saveBitloopsConfig(bitloopsConfig: BitloopsConfig) {
    //     global[LOCAL_STORAGE.BITLOOPS_CONFIG] = bitloopsConfig;
    //   }
    //   getBitloopsConfig(): BitloopsConfig {
    //     return global[LOCAL_STORAGE.BITLOOPS_CONFIG];
    //   }
    //   saveSubscriptionId(subscriptionId: string) {
    //     global[LOCAL_STORAGE.SUBSCRIPTION_ID] = subscriptionId;
    //   }
    //   getSubscriptionId() {
    //     return global[LOCAL_STORAGE.SUBSCRIPTION_ID];
    //   }
    //   deleteSubscriptionId() {
    //     delete global[LOCAL_STORAGE.SUBSCRIPTION_ID];
    //   }
    async saveSessionUuid(sessionId) {
        return keytar_1.default.setPassword("sessionUuid" /* SESSION_UUID */, this.account, sessionId);
    }
    async getSessionUuid() {
        return keytar_1.default.getPassword("sessionUuid" /* SESSION_UUID */, this.account);
    }
    async deleteSessionUuid() {
        const result = await keytar_1.default.deletePassword("sessionUuid" /* SESSION_UUID */, this.account);
        if (result === false)
            Promise.reject(result);
    }
    async saveUser(bitloopsUser) {
        return keytar_1.default.setPassword("bitloops.auth.userData" /* USER_DATA */, this.account, JSON.stringify(bitloopsUser));
    }
    async getUser() {
        const result = await keytar_1.default.getPassword("bitloops.auth.userData" /* USER_DATA */, this.account);
        return result ? JSON.parse(result) : null;
    }
    async deleteUser() {
        const result = await keytar_1.default.deletePassword("bitloops.auth.userData" /* USER_DATA */, this.account);
        if (result === false)
            Promise.reject(result);
    }
}
exports.default = CredentialsStorage;
//# sourceMappingURL=CredentialsStorage.js.map